import { render, staticRenderFns } from "./PersonHeader.vue?vue&type=template&id=14439d66&scoped=true&"
import script from "./PersonHeader.vue?vue&type=script&lang=js&"
export * from "./PersonHeader.vue?vue&type=script&lang=js&"
import style0 from "./PersonHeader.vue?vue&type=style&index=0&id=14439d66&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14439d66",
  null
  
)

export default component.exports